enum EnumParams {
  deviceId = 'deviceId',
  orgId = 'orgid',
  simId = 'simId',
  batchJobId = 'batchJobId',
}

export default EnumParams;
